import { BaseService } from './base.service';
import { api } from '../client/axiosClient';
import { CustomResponseEntity } from '../types/common';
import {
  ReportTemplateDto,
  CreateReportTemplateDto,
  UpdateReportTemplateDto,
} from '../types/dtos/report';

const BASE_PATH = '/api/v1/report-templates';

export class ReportTemplateService extends BaseService<
  ReportTemplateDto,
  CreateReportTemplateDto,
  UpdateReportTemplateDto
> {
  constructor() {
    super(BASE_PATH);
  }

  findAll(): Promise<CustomResponseEntity<ReportTemplateDto[]>> {
    return api.get(BASE_PATH);
  }

  findById(id: string): Promise<CustomResponseEntity<ReportTemplateDto>> {
    return api.get(`${BASE_PATH}/${id}`);
  }

  create(data: CreateReportTemplateDto): Promise<CustomResponseEntity<ReportTemplateDto>> {
    return api.post(BASE_PATH, data);
  }

  update(id: string, data: UpdateReportTemplateDto): Promise<CustomResponseEntity<ReportTemplateDto>> {
    return api.put(`${BASE_PATH}/${id}`, data);
  }

  delete(id: string): Promise<CustomResponseEntity<void>> {
    return api.delete(`${BASE_PATH}/${id}`);
  }

  getContent(id: string): Promise<CustomResponseEntity<string>> {
    return api.get(`${BASE_PATH}/${id}/content`);
  }
}

export const reportTemplateService = new ReportTemplateService();
